import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../_services/user.service';

@Injectable()
export class RoleGuard implements CanActivate {

    constructor(private router: Router, private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';
        
        // For SSR: Allow access (server can't check localStorage)
        // Client-side role check will happen after hydration
        if (!isBrowser) {
            return true;
        }
        
        if (localStorage.getItem('currentUser')) {
            if (this.userService.isAdmin() ) {
                return true;
            }
        }
        // not logged in so redirect to login page with the return url
        this.userService.isLoggedIn() ? this.router.navigate(['/user/dashboard']) : this.backToLogin(state);
        return false;
    }

    private  backToLogin (state: RouterStateSnapshot) {
        this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
    }

}
